import {
    DeleteOutlined,
    EditFilled,
    ExclamationCircleOutlined,
    ZoomInOutlined
} from "@ant-design/icons";
import { Button, Col, Image, Modal, Tag, Spin } from "antd";
import { useEffect, useState } from "react";
import { authApis } from "../../../services/authApi";
import Paginate from "../../../commons/Paginate";
import MainLayout from "../../../components/mainLayout";
import "./index.scss";
import { ROOT_URL } from "../../../constants/api";
import { Link } from "react-router-dom";
import { nofication } from "../../../commons/Nofication";

const Register = () => {
    const [newsList, setNewsList] = useState([]);
    const [totalItem, setTotalItem] = useState(0);
    const [paginateCurrent, setPaginateCurrent] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [datashow, setDatashow] = useState({});
    const [ids, setIds] = useState([]);

    useEffect(() => {
        fetchData();
    }, [paginateCurrent, perPage, searchValue]);

    const fetchData = () => {
        const urlParams = `page=${paginateCurrent}&perPage=${perPage}&search=${searchValue}`;
        authApis
            .getContactList(urlParams)
            .then((data) => {
                setNewsList(data.contacts.data ?? []);
                setTotalItem(data.contacts.total ?? 0);
                setIsLoading(false);
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Lấy dữ liệu thất bại");
            });
    };

    const onDelete = (id) => {
        authApis
            .deleteContact(id)
            .then((data) => {
                nofication("success", "Thành công!", "Xóa dữ liệu thành công!");
                fetchData();
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Lấy dữ liệu thất bại");
            });
    };
    const onConfirmDelete = (id) => {
        Modal.confirm({
            title: "Confirm",
            icon: <ExclamationCircleOutlined />,
            content: "Bạn có muốn xóa?",
            okText: "Ok",
            cancelText: "Cancel",
            onOk: () => {
                onDelete(id);
            },
            onCancel() {
                return;
            },
        });
    };
    const openModal = (id) => {
        setDatashow(newsList.find((item => item.id === id)));
        setIsModalVisible(true);
    };
    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const select = (id, e) => {
        if (e.target.checked === true) {
            setIds([...ids, id]);
        } else {
            setIds([...ids.filter((item => item !== id))]);
        }
    };

    return (
        <MainLayout
            isShowActionHeader={true}
            title="Order Design"
            link="/contact-design/"
            titleNew="New Order Design / List"
            setSearchValue={setSearchValue}
            isCreate={false}
            isHiddenAction={true}
            isContact={true}
            ids={ids}
            setIds={setIds}
        >
            <Modal title="Detail Infor" onOk={handleOk} onCancel={handleCancel} visible={isModalVisible}>
                <p><b>Họ tên:</b>{datashow.name}</p>
                <p><b>Phone:</b> {datashow.phone}</p>





                <p><b>Chữ Neon:</b> {datashow.textNeon}</p>
                <p><b>Color:</b> {datashow.color}</p>
                <p><b>Font:</b> {datashow.font}</p>
                <p><b>Note:</b> {datashow.note}</p>
            </Modal>
            <Spin spinning={isLoading} >
                <Col span={24} className='main-min-height-table'>
                    <div
                        style={{
                            width: "100%",
                            margin: "20px 10px 0px 0px",
                            padding: "20px",
                            borderTopRightRadius: "10px",
                            borderTopLeftRadius: "10px",
                            background: "white",
                        }}
                        className="table"
                    >
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    {/* <th scope="col">Select</th> */}
                                    <th scope="col">STT</th>
                                    <th scope="col" style={{ width: "100px" }} >Date</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Phone</th>
                                    <th scope="col">Chữ Neon</th>
                                    <th scope="col">Color</th>
                                    <th scope="col">Font</th>
                                    <th scope="col">Note</th>
                                    {/* <th scope="col">Email</th> */}
                                    {/* <th scope="col">Action</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {newsList.length ? (
                                    newsList.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                {/* <th scope="row">
                                                    <input type="checkbox" onClick={(e) => select(item.id, e)} />
                                                </th> */}
                                                <th scope="row">{index + 1}</th>
                                                <td>
                                                    {item.created_at.split("T")[0] + " " + item.created_at.split("T")[1].slice(0, 8)}
                                                </td>
                                                <th scope="row">
                                                    {item.name}
                                                </th>
                                                <td>
                                                    {item.phone}
                                                </td>
                                                <td>
                                                    {item.textNeon}
                                                </td>
                                                <td>
                                                    {item.color}
                                                </td>
                                                <td>
                                                    {item.font}
                                                </td>
                                                <td>
                                                    {item.noteGuest}
                                                </td>
                                                {/* <td>{item.email}</td> */}
                                                {/* <td>
                                                    <Link
                                                        to={`/contact/detail/${item.id}`}
                                                    >
                                                        <Button
                                                            icon={
                                                                <ZoomInOutlined />
                                                            }
                                                            style={{
                                                                color: "white",
                                                                background:
                                                                    "black",
                                                                border: "black",
                                                            }}
                                                            // onClick={() =>
                                                            //     openModal(
                                                            //         item.id
                                                            //     )
                                                            // }
                                                        ></Button>
                                                    </Link>
                                                    <Button
                                                        icon={
                                                            <DeleteOutlined />
                                                        }
                                                        onClick={() =>
                                                            onConfirmDelete(
                                                                item.id
                                                            )
                                                        }
                                                        style={{
                                                            color: "white",
                                                            background:
                                                                "#ab1a1a",
                                                            border: "#ab1a1a",
                                                            marginLeft: 10,
                                                        }}
                                                    ></Button>
                                                </td> */}
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        {isLoading === false ? (
                                            <td colspan="9">
                                                <h4
                                                    style={{
                                                        textAlign: "center",
                                                        margin: "20px 0px",
                                                    }}
                                                >
                                                    (No data)
                                                </h4>
                                            </td>
                                        ) : (
                                            <></>
                                        )}
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div style={{
                        width: "100%",
                        padding: "20px",
                        background: "white",
                        borderBottomRightRadius: "10px",
                        borderBottomLeftRadius: "10px",
                    }}>
                        <Paginate
                            setPaginateCurrent={setPaginateCurrent}
                            setPerPage={setPerPage}
                            totalItem={totalItem}
                            currentPage={paginateCurrent}
                        />
                    </div>
                </Col>
            </Spin>
        </MainLayout>
    );
};

export default Register;
